/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const FeaturePage = lazyLoad(
  () => import('./index'),
  module => module.FeaturePage
);
